import React from "react";
import RoundCheckbox from "./components/RoundCheckbox";
import RefundItemAccordion from "./components/RefundItemAccordion";
import styles from "../../styles.module.scss";
import { formattedPrice } from "../../../../../../views/pages/manage/unAssigned/collectPayment/utils";
import { CONCESSION_REFUND } from "../../utils";
import SubTypeRefundDetailsForm from "./components/SubTypeRefundDetailsForm";
import DownloadSupportingDoc from "./components/DownloadSupportingDoc";
import ConcessionRefundTypes from "./components/ConcessionRefundTypes";
const CONCESSION_FIELDS = [
  { formKey: "cmpConcession", refundKey: "cmprRefundAmount" },
  { formKey: "admissionConcession", refundKey: "admRefundAmount" },
  { formKey: "registrationConcession", refundKey: "regRefundAmount" },
];

const ConcessionRefundItem = ({
  payableRefundInfo,
  selectedRefundItems,
  refundItemCheckboxHandler,
  refundDetailsForm,
  handleRefundDetailsForm,
  isFullRefund,
  viewOnly,
  refundReasons,
  isLoanCase,
  setLoading,
  forRefundEdit,
}) => {

  const { totalRefundableAmount, courseId, ...restDetails } =
    payableRefundInfo?.[CONCESSION_REFUND] ?? {};
  const isDisabled = isFullRefund || !totalRefundableAmount;

  const isSelected = selectedRefundItems?.includes(CONCESSION_REFUND);
  const refundItemFormHandler = (key, value) =>
    handleRefundDetailsForm(key, value, CONCESSION_REFUND);
  const { cmprRefundAmount, admRefundAmount, regRefundAmount } = restDetails;

 const getTotalSelectedConcessionAmount = () => {
  const form = refundDetailsForm[CONCESSION_REFUND] || {};
  return CONCESSION_FIELDS.reduce(
    (sum, field) => sum + (form[field.formKey] || 0),
    0
  );
};


  const enableItemSelection = !viewOnly && !forRefundEdit;
  const handleCheckboxChange = (checked) => {

    refundItemCheckboxHandler(CONCESSION_REFUND, checked, true);
    CONCESSION_FIELDS.forEach(({ formKey, refundKey }) => {
    const value = checked ? restDetails?.[refundKey] || 0 : 0;
    refundItemFormHandler(formKey, value);
  });
  
  };
  // todo need to remove the disable logic and just rely on backend to send the refundable amount as 0 and show the tooltip for non refundable items. This will avoid the complex disable logic on frontend and also handle the edge cases where some items are non refundable based on certain conditions. For now keeping the disable logic as is and will remove it in future once we have the backend support for it.
  return (
    <RefundItemAccordion
    // isDisabled={isDisabled}
    >
      <div className="d-flex align-items-center">
        {enableItemSelection && (
          <RoundCheckbox
            isChecked={isSelected}
            onChange={handleCheckboxChange}
            isDisabled={isDisabled}
          />
        )}

        <div className={`${styles["accordion-title"]} mr-1`}>Concession •</div>

        <div className={`${styles["amount"]}`}>
          {formattedPrice(getTotalSelectedConcessionAmount())}
        </div>
        <div className="d-flex ml-auto">
          <div className={styles["withdrawal-week-chip"]}>
            Course ID : {courseId}
          </div>

          <DownloadSupportingDoc
            isDisabled={isDisabled}
            isSelected={isSelected}
            refundDetailsForm={refundDetailsForm}
            refundSubType={CONCESSION_REFUND}
            isLoanCase={isLoanCase}
            setLoading={setLoading}
          />
        </div>
      </div>
      <div>
        <ConcessionRefundTypes
          refundDetails={restDetails}
          refundItemName={CONCESSION_REFUND}
          refundDetailsForm={refundDetailsForm}
          handleRefundDetailsForm={handleRefundDetailsForm}
          formattedPrice={formattedPrice}
          refundItemCheckboxHandler={refundItemCheckboxHandler}
        />
        <SubTypeRefundDetailsForm
          refundItemName={CONCESSION_REFUND}
          form={refundDetailsForm}
          formHandler={handleRefundDetailsForm}
          amountFieldRequired
          maxRefundAmount={totalRefundableAmount}
          isDisabled={isDisabled || !isSelected || viewOnly}
          reasonsDropdownData={refundReasons?.[CONCESSION_REFUND]}
          isLoanCase={isLoanCase}
        />
      </div>
    </RefundItemAccordion>
  );
};

export default ConcessionRefundItem;
